import { useCallback, useEffect, useState } from "react";
import baseUrl from "../api/baseUrl";

function isExpired(isoString: string): boolean {
  const target = new Date(isoString);
  return target.getTime() - Date.now() <= 0;
}

export function useSubscriptionExpired() {
  const [expired, setExpired] = useState(false);
  const [expiryDate, setExpiryDate] = useState<Date | null>(null);

  const refresh = useCallback(async () => {
    try {
      const response = await baseUrl.get(
        "client/payment/getCientClinicPaymentbyId"
      );
      if (response?.data?.success) {
        const target = new Date(response.data.data);
        setExpiryDate(target);
        setExpired(isExpired(response.data.data));
      } else {
        setExpiryDate(null);
        setExpired(false);
      }
    } catch {
      setExpired(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (!expiryDate) return;

    const id = window.setInterval(() => {
      setExpired(expiryDate.getTime() - Date.now() <= 0);
    }, 1000);

    return () => window.clearInterval(id);
  }, [expiryDate]);

  return { expired, refresh };
}
